// third-party
import { createSlice } from '@reduxjs/toolkit';

// project imports
import { dispatch } from '../index';
import * as clinicFeaturesAPI from 'api/clinicFeatures';
import * as alertSnackbar from 'utils/snackbar-wrapper';

const initialState = {
    error: false,
    loaded: false,
    data: {
        outboundCallingEnabled: false,
        medhxEnabled: false
    }
};

const slice = createSlice({
    name: 'clinicFeatures',
    initialState,
    reducers: {
        setFeaturesError(state) {
            state.error = true;
            state.loaded = true;
        },
        setFeatures(state, action) {
            state.error = false;
            state.loaded = true;
            state.data = action.payload;
        },
        resetFeaturesState() {
            return initialState;
        }
    }
});

// Reducer
export default slice.reducer;

// ----------------------------------------------------------------------

export function resetClinicFeaturesState() {
    dispatch(slice.actions.resetFeaturesState());
}

export function getClinicFeatures(clinicId) {
    return async () => {
        try {
            const response = await clinicFeaturesAPI.getClinicFeatures(clinicId);
            dispatch(slice.actions.setFeatures(response.data));
        } catch (e) {
            // The axios interceptor rejects with the server's error body ({ statusCode,
            // message }) or the string 'Wrong Services' when there was no response.
            const reason = typeof e === 'string' ? e : e?.message ?? 'unknown error';
            dispatch(alertSnackbar.error(`Failed to fetch clinic features: ${reason}`));
            dispatch(slice.actions.setFeaturesError());
        }
    };
}
